import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter2",
  "use": "icon-filter2-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1.9142C0 1.36191 0.447713 0.9142 1 0.9142H11C11.5523 0.9142 12 1.36191 12 1.9142V3.30473C12 3.65835 11.8595 3.99749 11.6095 4.24753L8 7.857V12.8063C8 13.3515 7.42633 13.7061 6.93873 13.4623L4.46065 12.2232C4.17833 12.0821 4 11.7935 4 11.4779V7.857L0.390527 4.24753C0.140473 3.99749 0 3.65835 0 3.30473V1.9142ZM1 2.00785V3.30473L4.70713 7.0118C4.89467 7.1994 5 7.45373 5 7.71893V11.2931L7.07443 12.3286V7.71893C7.07443 7.45373 7.17976 7.1994 7.3673 7.0118L11.0744 3.30473V2.00785H1Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/filter2.svg
// module id = DuEb
// module chunks = 258